const placeholders = {
    default: {
        welcome: 'Welcome',
        provideDetails: 'Please provide your details to continue',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phoneNo: 'Phone Number',
        next: 'Next',
        whatsUp: "What's wrong",
        explainFeels: 'Please explain to us how you feel',
        unsubscribe: 'Unsubscribe from our services?',
        submit: 'Send',
        tellUs: 'Tell us...',
        thankYou: 'Thank you for your inquiry',
        getBack: "Your request will be processed as soon as possible. We will contact you shortly.",
        bestRegards: 'Best regards,',
        unsubscribed: 'We have unsubscribed you from all our services.',
        required: 'This field is required',
        invalidMail: 'Has to be a valid mail address',
        invalidNumber: 'Has to be a number',
    },
    US: {
        provideDetails: 'Please provide your details to verify your request on the next page. If you are a Californian please select this here below and know that this page is intended to be titled as ‘Do Not Sell My Personal Information’ page.',
        optoutService: "From which service would you like to opt-out",
        state: 'Select state'
    },
    DK: {
        welcome: 'Velkommen',
        provideDetails: 'INDTAST DINE OPLYSNINGER<br/>Hvis behandlingen af dine personoplysninger er baseret på dit samtykke, har du ret til at tilbagekalde dit samtykke til enhver tid ved enten at bruge de frameldingsfunktioner, som er fremhævet i den seneste kommunikation modtaget fra os, eller ved at du kontakter os ved hjælp af kontaktoplysningerne nedenfor. Din tilbagekaldelse vil ikke have betydning for lovligheden af behandlingen foretaget inden din tilbagekaldelse af dit samtykke.',
        firstName: 'Fornavn',
        lastName: 'Efternavn',
        phoneNo: 'Mobiltelefonnummer',
        email: 'E-mail',
        next: 'Fortsæt',
        privacy_policy_link_name: 'Fortrolighedspolitik',
        privacy_policy_link_href: 'https://consumers-connect.com/denmark/fortrolighedspolitik/'
    }
};

export default placeholders;
